import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const AppProviders = lazy(() => import('@app/components/AppProviders'))
const ScreenshotsFooter = lazy(() => import('.'))

class ScreenshotsFooterComponent extends ReactWebComponent {
	override render() {
		return (
			<AppProviders>
				<ScreenshotsFooter />
			</AppProviders>
		)
	}
}

customElements.define('screenshots-footer', ScreenshotsFooterComponent)
